export default __webpack_public_path__ + "static/media/de.ed5be695.svg";